import React from 'react'
import { Badge, ListGroup } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { provinceMap } from '../lib/utils'

const ResultsView = ({ results }) =>
  results.length
    ? (
      <ListGroup>
        {results.map(r => <PersonItem key={r.darn} person={r} />)}
      </ListGroup>
      )
    : <span>No results found.</span>

const PersonItem = ({ person }) => {
  const { darn, surname, firstname, position, staff, pubRep, member, candidate } = person

  const displayPosition = pubRep
    ? `${pubRep.position}, ${pubRep.legislature}, ${provinceMap[pubRep.province]}`
    : (staff ? `${staff.position}, ${staff.department}` : position)

  return (
    <LinkContainer to={`/person/${darn}`}>
      <ListGroup.Item action>
        <span>{surname}, {firstname}</span>{' '}
        {pubRep ? <Badge variant='primary'>Public Rep</Badge> : null}{' '}
        {staff ? <Badge variant='success'>Staff</Badge> : null}{' '}
        {candidate ? <Badge variant='warning'>Candidate</Badge> : null}{' '}
        {member ? <Badge variant='info'>Member</Badge> : null}{' '}
        <br />
        <small class='text-muted text-uppercase'>{displayPosition}</small>
      </ListGroup.Item>
    </LinkContainer>
  )
}

export default ResultsView
